// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"franchise-comparison_outerContainer__GdyLF","heading":"franchise-comparison_heading__2ajGF","wrapper":"franchise-comparison_wrapper__ebdVT"};